// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../usr/local/lib/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical-timeline.vertical-timeline-custom-line::before {\n  background: #3b7696;\n}\n", ""]);
// Exports
module.exports = exports;
